// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables */
:root {
  --primary: #1d5d9b;
}

/* CSS Reset */
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-decoration: none;
  list-style-type: none;
}
/* End CSS Reset */

html {
  scroll-behavior: smooth;
}

/* Navbar */
.skip-link {
  position: absolute;
  top: -50px;
  left: 0;
  padding: 8px;
  background-color: #1d5d9b;
  color: white;
  z-index: 9999;
  min-width: 44px;
  min-height: 44px;
}

.skip-link:focus {
  top: 0;
}

.navbar-container {
  width: 100%;
  margin-inline: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-block: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 999;
}

.logo .navbar-brand {
  font-size: 2rem;
  color: black;
  font-family: 'Lobster', cursive;
  min-width: 44px;
  min-height: 44px;
  display: inline-block;
}

span {
  color: var(--primary);
}

nav .navbar-list {
  padding-left: 0;
  display: flex;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
}

nav .navbar-list a {
  font-family: 'Rubik', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: black;
  padding: 0.7rem 1.5rem;
  display: inline-block;
  min-width: 44px;
  min-height: 44px;
}

nav .navbar-list a:hover {
  color: var(--primary);
}

/* End Navbar */

/* Hero */
.hero {
  position: relative;
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  font-family: 'Rubik', sans-serif;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.hero .hero-text {
  margin: auto;
  z-index: 2;
}

.hero .hero-text h1 {
  color: white;
  font-size: 3rem;
}

.hero .hero-text p {
  text-align: center;
  color: white;
  font-size: 1.5rem;
  margin-top: 5px;
  font-weight: 500;
}

.hero .hero-text .cta-container {
  text-align: center;
  margin-top: 12px;
}

.hero .hero-text .cta-container .cta {
  display: inline-block;
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  color: white;
  background-color: var(--primary);
  border-radius: 0.7rem;
  box-shadow: 1px 1px 3px rgba(1, 1, 3px, 0.5);
  cursor: pointer;
  transition: transform 0.2s ease;
  font-weight: 500;
  min-width: 44px;
  min-height: 44px;
}

.hero .hero-text .cta-container .cta:hover {
  transform: scale(1.05);
}
/* End Hero */

/* Content */
main {
  font-family: 'Rubik', sans-serif;
}

main h2 {
  margin: 1.3rem auto;
  font-size: 2rem;
}

main .content h2 {
  text-align: center;
}

.content .explore-restaurant-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.card {
  width: 325px;
  height: 370px;
  background-color: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  margin: 20px;
  position: relative;
}

.card:hover {
  box-shadow: -2px -1px 25px -4px rgba(0, 0, 0, 0.75);
}

.card img {
  width: 350px;
  height: 200px;
  object-fit: cover;
  cursor: pointer;
  transition:
    transform 0.3s,
    filter 0.3s;
}

.card img:hover {
  transform: scale(1.1);
}

.card-content {
  padding: 16px;
  max-width: 300px;
  text-overflow: ellipsis;
}

.card-content h1 {
  font-size: 30px;
  margin-bottom: 8px;
}

.card-city {
  background-color: var(--primary);
  position: absolute;
  border-radius: 10px 0 10px;
  top: -2px;
  left: -2px;
  font-size: 1.2rem;
  padding: 5px;
  font-weight: 700;
  color: white;
}

.card-name {
  color: var(--primary);
}

.rating-container {
  right: 30px;
  top: 220px;
  position: absolute;
}

.fa-star {
  color: var(--primary);
}

.card-rating {
  color: var(--primary);
  display: inline-block;
}

.card-desc {
  padding-top: 10px;
  font-size: 0.8rem;
  color: #666;
}
/* End Content */

/* to Top Icon*/
.to-top {
  background: #3a78b6;
  position: fixed;
  bottom: 16px;
  right: 32px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: white;
  opacity: 0;
  pointer-events: none;
  transition: all 0.4s;
  min-width: 44px;
  min-height: 44px;
  border: none;
  cursor: pointer;
}

.to-top.active {
  bottom: 32px;
  pointer-events: auto;
  opacity: 1;
}
/* End to Top Icon*/

/* Footer */
footer {
  background-color: var(--primary);
  padding: 1.7rem;
  font-family: 'Rubik', sans-serif;
}

.social-media,
.menu,
.copyright {
  padding: 0.7rem 0 0.7rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu a {
  display: inline-block;
  min-width: 44px;
  min-height: 44px;
  padding-top: 0.8rem;
}

.social-media a i {
  min-width: 44px;
  min-height: 44px;
  font-size: 44px;
}

footer a,
footer p {
  color: white;
  padding: 0 1rem 0 1rem;
}

footer a i {
  font-size: 2rem;
}

footer a:hover {
  color: black;
}
/* End Footer */

/* Loading and Error */
.loading-indicator {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-message {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5em;
  color: red;
}

/* End Loading and Error */
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;AACA,kBAAkB;;AAElB;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,wDAAwD;EACxD,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,eAAe;;AAEf,SAAS;AACT;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yDAA8D;EAC9D,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,qBAAqB;EACrB,4CAA4C;EAC5C,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA,aAAa;;AAEb,YAAY;AACZ;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;AACA,gBAAgB;;AAEhB,eAAe;AACf;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;AACA,mBAAmB;;AAEnB,WAAW;AACX;EACE,gCAAgC;EAChC,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA,eAAe;;AAEf,sBAAsB;AACtB;EACE,0BAA0B,EAAE,eAAe;EAC3C,8BAA8B,EAAE,SAAS;EACzC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,0BAA0B","sourcesContent":["/* variables */\n:root {\n  --primary: #1d5d9b;\n}\n\n/* CSS Reset */\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  text-decoration: none;\n  list-style-type: none;\n}\n/* End CSS Reset */\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Navbar */\n.skip-link {\n  position: absolute;\n  top: -50px;\n  left: 0;\n  padding: 8px;\n  background-color: #1d5d9b;\n  color: white;\n  z-index: 9999;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.skip-link:focus {\n  top: 0;\n}\n\n.navbar-container {\n  width: 100%;\n  margin-inline: auto;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding-block: 1rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 999;\n}\n\n.logo .navbar-brand {\n  font-size: 2rem;\n  color: black;\n  font-family: 'Lobster', cursive;\n  min-width: 44px;\n  min-height: 44px;\n  display: inline-block;\n}\n\nspan {\n  color: var(--primary);\n}\n\nnav .navbar-list {\n  padding-left: 0;\n  display: flex;\n  justify-content: center;\n  min-width: 44px;\n  min-height: 44px;\n}\n\nnav .navbar-list a {\n  font-family: 'Rubik', sans-serif;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: black;\n  padding: 0.7rem 1.5rem;\n  display: inline-block;\n  min-width: 44px;\n  min-height: 44px;\n}\n\nnav .navbar-list a:hover {\n  color: var(--primary);\n}\n\n/* End Navbar */\n\n/* Hero */\n.hero {\n  position: relative;\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  align-items: center;\n  background-image: url(../public/images/heros/hero-image_2.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  font-family: 'Rubik', sans-serif;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 1;\n}\n\n.hero .hero-text {\n  margin: auto;\n  z-index: 2;\n}\n\n.hero .hero-text h1 {\n  color: white;\n  font-size: 3rem;\n}\n\n.hero .hero-text p {\n  text-align: center;\n  color: white;\n  font-size: 1.5rem;\n  margin-top: 5px;\n  font-weight: 500;\n}\n\n.hero .hero-text .cta-container {\n  text-align: center;\n  margin-top: 12px;\n}\n\n.hero .hero-text .cta-container .cta {\n  display: inline-block;\n  padding: 0.8rem 2rem;\n  font-size: 1.1rem;\n  color: white;\n  background-color: var(--primary);\n  border-radius: 0.7rem;\n  box-shadow: 1px 1px 3px rgba(1, 1, 3px, 0.5);\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  font-weight: 500;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.hero .hero-text .cta-container .cta:hover {\n  transform: scale(1.05);\n}\n/* End Hero */\n\n/* Content */\nmain {\n  font-family: 'Rubik', sans-serif;\n}\n\nmain h2 {\n  margin: 1.3rem auto;\n  font-size: 2rem;\n}\n\nmain .content h2 {\n  text-align: center;\n}\n\n.content .explore-restaurant-content {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.card {\n  width: 325px;\n  height: 370px;\n  background-color: #f0f0f0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  margin: 20px;\n  position: relative;\n}\n\n.card:hover {\n  box-shadow: -2px -1px 25px -4px rgba(0, 0, 0, 0.75);\n}\n\n.card img {\n  width: 350px;\n  height: 200px;\n  object-fit: cover;\n  cursor: pointer;\n  transition:\n    transform 0.3s,\n    filter 0.3s;\n}\n\n.card img:hover {\n  transform: scale(1.1);\n}\n\n.card-content {\n  padding: 16px;\n  max-width: 300px;\n  text-overflow: ellipsis;\n}\n\n.card-content h1 {\n  font-size: 30px;\n  margin-bottom: 8px;\n}\n\n.card-city {\n  background-color: var(--primary);\n  position: absolute;\n  border-radius: 10px 0 10px;\n  top: -2px;\n  left: -2px;\n  font-size: 1.2rem;\n  padding: 5px;\n  font-weight: 700;\n  color: white;\n}\n\n.card-name {\n  color: var(--primary);\n}\n\n.rating-container {\n  right: 30px;\n  top: 220px;\n  position: absolute;\n}\n\n.fa-star {\n  color: var(--primary);\n}\n\n.card-rating {\n  color: var(--primary);\n  display: inline-block;\n}\n\n.card-desc {\n  padding-top: 10px;\n  font-size: 0.8rem;\n  color: #666;\n}\n/* End Content */\n\n/* to Top Icon*/\n.to-top {\n  background: #3a78b6;\n  position: fixed;\n  bottom: 16px;\n  right: 32px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  color: white;\n  opacity: 0;\n  pointer-events: none;\n  transition: all 0.4s;\n  min-width: 44px;\n  min-height: 44px;\n  border: none;\n  cursor: pointer;\n}\n\n.to-top.active {\n  bottom: 32px;\n  pointer-events: auto;\n  opacity: 1;\n}\n/* End to Top Icon*/\n\n/* Footer */\nfooter {\n  background-color: var(--primary);\n  padding: 1.7rem;\n  font-family: 'Rubik', sans-serif;\n}\n\n.social-media,\n.menu,\n.copyright {\n  padding: 0.7rem 0 0.7rem 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.menu a {\n  display: inline-block;\n  min-width: 44px;\n  min-height: 44px;\n  padding-top: 0.8rem;\n}\n\n.social-media a i {\n  min-width: 44px;\n  min-height: 44px;\n  font-size: 44px;\n}\n\nfooter a,\nfooter p {\n  color: white;\n  padding: 0 1rem 0 1rem;\n}\n\nfooter a i {\n  font-size: 2rem;\n}\n\nfooter a:hover {\n  color: black;\n}\n/* End Footer */\n\n/* Loading and Error */\n.loading-indicator {\n  border: 16px solid #f3f3f3; /* Light grey */\n  border-top: 16px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.error-message {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5em;\n  color: red;\n}\n\n/* End Loading and Error */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
